module.exports = __webpack_public_path__ + "img/urCoursesWhite.73ab84f6.svg";